/**
 * Created by Jie Gao on 2018-11-09.
 */
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ISymbolValues} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {StarStruckParsedInitData} from "../../server/data/StarStruckParsedInitData";
import {StarStruckGameConfig} from "../../StarStruckGameConfig";

export interface miniPaytableSymbol {
    symbol:PIXI.Sprite;
    text:PIXI.Text;
}

export class MiniPayTable extends BaseView {
    protected _panel:PIXI.Graphics;
    protected _symbolSprites:miniPaytableSymbol[] = [];
    protected _wrapper:PIXI.Sprite;
    protected _config:any;
    protected _symbolValues:ISymbolValues;
    protected _currentBet:number;
    private _xOffset:number = 0;
    private _hasParsedInitData:boolean = false;

    constructor(config:any) {
        super();
        this._config = config;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, BalanceEvent.CURRENT_BET, (event:GameEvent) => this.onChangeBet(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.update());
    }

    private onInitGameDataParsed(data:StarStruckParsedInitData):void {
        this._hasParsedInitData = true;
        this._symbolValues = data.symbolValues;
    }

    public update():void {
        if(!this._hasParsedInitData) {
            return;
        }

        this._symbolSprites.forEach((symbolSprite:miniPaytableSymbol, i:number) => {
            const coinValue:number = this._symbolValues[this._config.values[i]][3];
            let displayValue:string = (coinValue * this._currentBet / 5).toFixed(2);
            if(displayValue.length > 4 && displayValue.endsWith(".00")) {
                const length = displayValue.length;
                displayValue = displayValue.slice(0, length - 3);
            }
            symbolSprite.text.scale.set(1);
            symbolSprite.text.text = displayValue;
            if(symbolSprite.text.width > 100) {
                symbolSprite.text.width = 100;
            }

            symbolSprite.text.scale.set(1);
            symbolSprite.text.x = this._xOffset - symbolSprite.text.width / 2;
        });
    }

    protected onChangeBet(bet:string):void {
        this._currentBet = parseFloat(bet);
    }

    protected initAnimations():void {
        this._wrapper = new PIXI.Sprite();
        this._panel = new PIXI.Graphics();
        this._wrapper.addChild(this._panel);
        this.addChild(this._wrapper);
        this._symbolSprites = ArrayHelper.initArrayWithValues(this._config.symbols.length, (i:number) => {return this.createSymbolContainer(i);});
    }

    protected createSymbolContainer(index:number):miniPaytableSymbol {
        return {
            symbol : new PIXI.Sprite(),
            text : new PIXI.Text("")
        }
    };

    protected onResize(data:IResizeData):void {
        this._xOffset = (data.orientation === Orientation.PORTRAIT) ? (StarStruckGameConfig.instance.SYMBOL_WIDTH * 0.35 * 0.5) : 120;
        this.update();
    };
}